import { motion } from 'framer-motion'
import { KineticGrid } from './KineticGrid'
import { Link } from 'react-router-dom'
import heroBgUrl from '@/assets/images/careerherobg.webp'

// Our three brand colors — dots blend through these as the cursor nears them.
const HERO_GLOW_COLORS = ['#D4575B', '#3B82F6', '#F5A623']

// ─── Hero ─────────────────────────────────────────────────────────────────────
export function HomeHero() {
  return (
    <section className="relative h-screen overflow-hidden bg-white" aria-label="Hero">
      {/* Soft gradient wash — rises from the bottom to cover the whole hero */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: `url(${heroBgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Kinetic grid */}
      <div className="pointer-events-none absolute inset-0">
        <KineticGrid
          background="transparent"
          dotColor="#292929"
          lineColor="#292929"
          glowColors={HERO_GLOW_COLORS}
          spacing={53}
          radius={171}
          strength={3}
          trail={false}
        />
      </div>

      <div className="container-site relative z-10 flex h-full flex-col items-center justify-center gap-6 pt-[80px] text-center xl:pt-0">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="font-sans text-[32px] font-light not-italic xl:leading-[110%] xl:tracking-[-3px] text-[#292929] sm:text-[44px] lg:text-[56px] xl:text-[64px]"
        >
          Build your business <br />
          <span className="font-medium">We'll build everything behind it!</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1, ease: 'easeOut' }}
          className="font-sans text-[14px] font-normal xl:leading-[1.6] text-[#979AC0] sm:text-[16px] w-full max-w-[650px] xl:text-[24px]"
        >
          From customer-facing products to the systems behind your business, we help you build,
          operate, and scale with confidence.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
          className="relative mt-2"
        >
          <div className="">
            <Link
              to="/contact"
              className="flex items-center justify-center gap-[8.772px] rounded-[8.772px] bg-black px-[17.544px] py-[12px] text-center text-[18px] font-medium leading-normal text-white transition-all duration-200 hover:bg-brand-gray-900 hover:shadow-sm active:scale-[0.98]"
              style={
                {
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  border: '0.877px solid rgba(255, 255, 255, 0.09)',
                } as React.CSSProperties
              }
            >
              Get Started
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
